export default "__VITE_ASSET__Bnb8C5ntEGZj3RdS__VIbA__"